import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SeasonCalendarComponentsModule } from '@app/activo2/manage-vacations/components/calendar-step/components/season-calendar-components.module';
import { ManageVacationsSharedModule } from '@app/activo2/manage-vacations/components/manage-vacations-shared.module';
import { ComponentsModule } from '@app/components/components.module';
import { ScheduleComponentsModule } from '@app/mot/schedule/components/schedule-components.module';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { CalendarStepComponent } from './calendar-step/calendar-step.component';
import { CriteriaModalComponent } from './criteria-modal/criteria-modal.component';
import { CriteriaStepComponent } from './criteria-step/criteria-step.component';
import { FirstStepComponent } from './first-step/first-step.component';
import { ProposalCardComponent } from './proposal-card/proposal-card.component';
import { ResumeComponent } from './resume/resume.component';

const components = [
  FirstStepComponent,
  ResumeComponent,
  CriteriaStepComponent,
  CriteriaModalComponent,
  ProposalCardComponent,
  CalendarStepComponent
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule.forChild(),
    ComponentsModule,
    SeasonCalendarComponentsModule,
    ScheduleComponentsModule,
    ManageVacationsSharedModule
  ],
  exports: components
})
export class MotVacationsStepperModule {}
